var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    fillRule: "evenodd",
    d: "M8,1.4c1.1,0,2.1,0,3.2,0.1c0.5,0,1,0.1,1.5,0.3c0.7,0.3,1.2,0.8,1.5,1.5 c0.2,0.5,0.3,1,0.3,1.5c0,0.8,0.1,1.1,0.1,3.2c0,1.1,0,2.1-0.1,3.2c0,0.5-0.1,1-0.3,1.5c-0.3,0.7-0.8,1.2-1.5,1.5 c-0.5,0.2-1,0.3-1.5,0.3c-0.8,0-1.1,0.1-3.2,0.1c-1.1,0-2.1,0-3.2-0.1c-0.5,0-1-0.1-1.5-0.3c-0.7-0.3-1.2-0.8-1.5-1.5 c-0.2-0.5-0.3-1-0.3-1.5c0-0.8-0.1-1.1-0.1-3.2c0-1.1,0-2.1,0.1-3.2c0-0.5,0.1-1,0.3-1.5C1.9,3,2.2,2.7,2.4,2.4 c0.2-0.3,0.5-0.5,0.9-0.6c0.5-0.2,1-0.3,1.5-0.3C5.9,1.4,6.9,1.4,8,1.4 M8,0C6.9,0,5.8,0,4.7,0.1c-0.7,0-1.3,0.1-2,0.4 c-0.5,0.2-1,0.5-1.4,0.9C0.9,1.7,0.6,2.2,0.5,2.8c-0.3,0.6-0.4,1.3-0.4,2C0,5.8,0,6.9,0,8c0,1.1,0,2.2,0.1,3.3c0,0.7,0.1,1.3,0.4,2 c0.2,0.5,0.5,1,0.9,1.4c0.4,0.4,0.9,0.7,1.4,0.9c0.6,0.2,1.3,0.4,2,0.4C5.8,16,6.9,16.1,8,16c1.1,0,2.2,0,3.3-0.1 c0.7,0,1.3-0.1,2-0.4c1.1-0.4,1.9-1.2,2.3-2.3c0.2-0.6,0.4-1.3,0.4-2c0-0.9,0.1-1.2,0.1-3.3c0-1.1,0-2.2-0.1-3.3 c0-0.7-0.1-1.3-0.4-2c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.9-0.7-1.4-0.9c-0.6-0.2-1.3-0.4-2-0.4C10.2,0,9.1,0,8,0 M8,3.9 c-2.2,0-4.1,1.7-4.1,4c0,0,0,0.1,0,0.1c0,2.3,1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1S10.3,3.9,8,3.9L8,3.9 M8,10.7 c-1.4,0-2.6-1.1-2.7-2.6c0,0,0-0.1,0-0.1c0-1.4,1.1-2.6,2.6-2.7c0,0,0.1,0,0.1,0c1.4,0,2.6,1.1,2.7,2.6c0,0,0,0.1,0,0.1 C10.7,9.5,9.6,10.7,8,10.7C8.1,10.7,8,10.7,8,10.7 M12.3,2.8c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v0 C13.3,3.2,12.8,2.8,12.3,2.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.878a8cbd89ff9a4ff92a5f0555493078.svg";
export { ForwardRef as ReactComponent };